export default {
  name: "CustomStyledSelect",
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: ""
    },
    optionTextColor: {
      type: String,
      default: "inherit"
    }
  },
  computed: {
    selectedOption() {
      return this.options.find(option => option.key === this.value);
    },
    displayText() {
      if (this.selectedOption) {
        return this.selectedOption.value;
      }
      return this.placeholder || "";
    }
  },
  methods: {
    selectOption(option) {
      if (!this.disabled) {
        this.$emit('change', option.key);
      }
    },
    handleChange(event) {
      if (!this.disabled) {
        this.$emit('change', event.target.value);
      }
    }
  }
};
